module.exports = "img/trans.0a14f5e.png";